export default __webpack_public_path__ + "media/images/header-small-logo-ac06148119e6fc161efda96cfb39791e.svg";